import React from "react";
import CustomSelect from "../../../NTICore/component/Form/SelectOption/CustomSelect";
import { fetchStates } from "../../../PartnerAgreement/service";
import classnames from "classnames";
import { errorWarning } from "../../../NTICore/component/Form/errorWaringFormMessage";

class States extends React.Component {
  state = {
    loading: false,
    states: [],
  };

  componentDidMount() {
    this.fetchData();
  }

  fetchData = async () => {
    try {
      this.setState({ loading: true });
      const response = await fetchStates();
      this.setState({ loading: false });
      this.setState({ states: response.data.data });
    } catch (e) {}
  };

  onChange = (value) => {
    const { input } = this.props;
    if (input.onChange && value != null) {
      // To be aligned with how redux-form publishes its CHANGE action payload. The event received is an object with 2 keys: "value" and "label"
      input.onChange(value);
    } else {
      // Clear the input field
      input.onChange(null);
    }
  };

  render() {
    const {
      input,
      meta: { touched, error, warning },
    } = this.props;

    return (
      <div className={classnames({ "has-error": touched && error })}>
        <CustomSelect
          placeholder={"State"}
          value={input ? input.value : null}
          onBlur={() => input.onBlur(input ? input.value : null)}
          options={this.state.states}
          autoload={false}
          onChange={this.onChange}
          valueKey={"id"}
          labelKey={"name"}
          isLoading={this.state.loading}
          hasError={touched && error}
        />
        {errorWarning(touched, error, warning)}
      </div>
    );
  }
}

export default States;



// WEBPACK FOOTER //
// ./src/modules/AppCore/Component/Geographic/States.js